module.exports = __webpack_public_path__ + "static/media/logoprojeto2.3c221dc2.png";